// extracted by css-extract-rspack-plugin
export default {"description":"jv0ti2h8g0YD4YBN","dialogBody":"kXqYyZq3CusBBN37","dialogFooter":"rIYuQRj1kkQCy5Km","error":"VXb6Od_g3k_adgip"};